import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpClientService: HttpClientService) { }

  public getAllCustomers(data: any, isShipToCustomer: boolean = false) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.GETALLCUSTOMER}?isShipToCustomer=${isShipToCustomer}`, data);
  }

  public getCustomerForOrder(data: any, isShipToCustomer: boolean = false) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.GETCUSTOMER_FOR_ORDER}?isShipToCustomer=${isShipToCustomer}`, data);
  }

  public getCustomerById(data: any) {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.CUSTOMER.GETCUSTOMER}?${queryParam}`);
  }

  public createCustomer(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.CREATECUSTOMER}`, data);
  }

  public updateCustomer(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.UPDATECUSTOMER}`, data);
  }

  public updateOutstandingReceivables(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.UPDATECUSTOMEROUTSTANDREC}`, data);
  }

  public deleteCustomer(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.DELETECUSTOMER}`, data);
  }
  public autogenerateCustomerCode() {
    return this.httpClientService.get(CONFIG.CUSTOMER.AUTOGENERATE_CUSTOMERCODE);
  }

  public checkCustomerCode(data: any) {
    return this.httpClientService.get(`${CONFIG.CUSTOMER.CHECK_CUSTOMER_CODE}?CustomerCode=${data}`);
  }

  public getStateList() {
    return this.httpClientService.get(CONFIG.CUSTOMER.GET_STATE_LIST);
  }

  public uploadCustomerImage(customerid: number, formData: FormData) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.UPLOAD_CUST_IMAGE}/${customerid} `, formData);
  }

  public getCustomerByNameOrCode(data: any) {
    return this.httpClientService.get(`${CONFIG.CUSTOMER.GET_CUSTOMER_BY_CODEORNAME}?CodeOrName=${data}`);
  }

  public CreateCustomerProduct(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.CREATE_CUSTOMER_PRODUCT}`, data);
  }

  public getCustomerProductList(data: any, customerId: number) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.GET_CUSTOMER_PRODUCT_LIST}?CustomerId=${customerId}`, data);
  }

  public deleteCustomerProduct(data: any[]) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.DELETE_CUSTOMER_PRODUCT}`, data);
  }
  public getOutstandingAmount(customerId: string | number) {
    return this.httpClientService.get(
      `${CONFIG.CUSTOMER.GETOUTSTANDINGAMOUNT}?customerId=${customerId}`
    );
  }

  public getGSTTreatments() {
    return this.httpClientService.get(CONFIG.CUSTOMER.GET_GST_TREATENTS);
  }

}
